<template>
  <div v-intersect="onIntersect" class="manual-rune" :class="classes">
    <div class="manual-rune__content">
      <ManualRuneImg :src="rune.img" :title="rune.name" />
      <div class="manual-rune__body">
        <h3 class="manual-rune__title">{{ rune.name }} Runes</h3>
        <div class="manual-rune__descriptions">
          <div
            v-for="(desc, index) in rune.descriptions"
            :key="index"
            class="manual-rune__description"
          >
            {{ desc }}
          </div>
        </div>
      </div>
      <ManualRuneImg :src="rune.img" :title="rune.name" big />
    </div>
  </div>
</template>

<script>
import ManualRuneImg from "./ManualRuneImg";

export default {
  name: "ManualRune",
  components: {
    ManualRuneImg
  },
  props: {
    left: Boolean,
    right: Boolean,
    intersected: Boolean,
    rune: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes() {
      return {
        [`color-${this.rune.type}`]: true,
        "is-hidden": !this.intersected,
        "manual-rune_left": this.left,
        "manual-rune_right": this.right
      };
    }
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (!isIntersecting) return;
      if (!this.intersected) {
        this.$emit("intersect", isIntersecting);
      }
    }
  }
};
</script>

<style lang="scss">
$p: ".manual-rune";

.manual-rune {
  font-family: "Montserrat";
  width: 650px;
  max-width: 100%;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    transition: 0.3s transform;
  }

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 5px;
    white-space: nowrap;
  }

  &__body {
    text-align: center;
    width: 320px;
  }

  &__descriptions {
    color: #fff;
  }

  &__description {
    font-size: 18px;
    line-height: 29px;
    position: relative;
    white-space: nowrap;
    padding: 0 10px;
    &::before,
    &::after {
      content: "+";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    &::before {
      left: 0;
      font-size: 18px;
    }
    &::after {
      right: 0;
      font-weight: bold;
      font-size: 32px;
    }
  }

  &.is-hidden {
    &#{$p}_left #{$p}__content {
      transform: translateX(-150%);
    }
    &#{$p}_right #{$p}__content {
      transform: translateX(150%);
    }
  }

  @include breakpoint("sm-and-down") {
    &__content {
      flex-wrap: wrap;
    }
    &__body {
      width: 100%;
      order: 3;
    }
    &__descriptions {
      width: 320px;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  @media (max-width: 375px) {
    &__descriptions {
      width: 280px;
    }
  }
}
</style>
